import React, { useState } from 'react';
function SharedGPA4to5() {
    const [originalGPA, setOriginalGPA] = useState('');
    const [convertedGPA, setConvertedGPA] = useState('');
    const [showResult, setShowResult] = useState(false);
    const [error, setError] = useState(null);
    const handleCalculateClick = () => {
        const gpa = parseFloat(originalGPA);
        if (!isNaN(gpa) && gpa >= 0.0 && gpa <= 4.0) {
            let converted = '';
            if (gpa >= 3.97) {
                converted = '4.95 ~ 5.00';
            } else if (gpa >= 3.92) {
                converted = '4.90 ~ 4.94';
            } else if (gpa >= 3.88) {
                converted = '4.84 ~ 4.89';
            } else if (gpa >= 3.84) {
                converted = '4.79 ~ 4.83';
            } else if (gpa >= 3.80) {
                converted = '4.73 ~ 4.78';
            } else if (gpa >= 3.75) {
                converted = '4.68 ~ 4.72';
            } else if (gpa >= 3.71) {
                converted = '4.62 ~ 4.67';
            } else if (gpa >= 3.67) {
                converted = '4.57 ~ 4.61';
            } else if (gpa >= 3.62) {
                converted = '4.51 ~ 4.56';
            } else if (gpa >= 3.58) {
                converted = '4.45 ~ 4.50';
            } else if (gpa >= 3.49) {
                converted = '4.34 ~ 4.44';
            } else if (gpa >= 3.41) {
                converted = '4.23 ~ 4.33';
            } else if (gpa >= 3.32) {
                converted = '4.12 ~ 4.22';
            } else if (gpa >= 3.24) {
                converted = '4.01 ~ 4.11';
            } else if (gpa >= 3.15) {
                converted = '3.90 ~ 4.00';
            } else if (gpa >= 3.07) {
                converted = '3.79 ~ 3.89';
            } else if (gpa >= 2.98) {
                converted = '3.68 ~ 3.78';
            } else if (gpa >= 2.90) {
                converted = '3.57 ~ 3.67';
            } else if (gpa >= 2.81) {
                converted = '3.45 ~ 3.56';
            } else if (gpa >= 2.72) {
                converted = '3.34 ~ 3.44';
            } else if (gpa >= 2.64) {
                converted = '3.23 ~ 3.33';
            } else if (gpa >= 2.56) {
                converted = '3.12 ~ 3.22';
            } else if (gpa >= 2.48) {
                converted = '3.01 ~ 3.11';
            } else if (gpa >= 2.40) {
                converted = '2.90 ~ 3.00';
            } else if (gpa >= 2.32) {
                converted = '2.79 ~ 2.89';
            } else if (gpa >= 2.24) {
                converted = '2.68 ~ 2.78';
            } else if (gpa >= 2.16) {
                converted = '2.57 ~ 2.67';
            } else if (gpa >= 2.08) {
                converted = '2.46 ~ 2.56';
            } else if (gpa >= 2.00) {
                converted = '2.35 ~ 2.45';
            } else if (gpa >= 1.92) {
                converted = '2.24 ~ 2.34';
            } else if (gpa >= 1.84) {
                converted = '2.13 ~ 2.23';
            } else if (gpa >= 1.75) {
                converted = '2.02 ~ 2.12';
            } else if (gpa >= 1.67) {
                converted = '1.92 ~ 2.01';
            } else if (gpa >= 1.59) {
                converted = '1.82 ~ 1.91';
            } else if (gpa >= 1.51) {
                converted = '1.71 ~ 1.81';
            } else if (gpa >= 1.43) {
                converted = '1.60 ~ 1.70';
            } else if (gpa >= 1.35) {
                converted = '1.50 ~ 1.59';
            } else if (gpa >= 1.26) {
                converted = '1.40 ~ 1.49';
            } else if (gpa >= 1.18) {
                converted = '1.31 ~ 1.39';
            } else if (gpa >= 1.09) {
                converted = '1.21 ~ 1.30';
            } else if (gpa >= 1.00) {
                converted = '1.11 ~ 1.20';
            } else {
                converted = '0.00 ~ 0.99';
            }
            setConvertedGPA(converted);
            setShowResult(true);
            setError(null);
        } else {
            setError('ادخل قيمة صحيحة بين 0 و 4.0');
            setShowResult(false);
        }
    };
    return (
        <div className="rtl">
            <div className="row">
                <div className="col-sm-12 col-md-7 calculatorStyle">
                    <div className="p-3 mb-2 bg-success text-white">
                        <h2 style={{ fontSize: '16px' }}>تحويل المعدل التراكمي من 4.0 إلى 5.0</h2>
                    </div>
                    <hr />
                    <div className="form-group d-flex align-items-center">
                        <b><label htmlFor='originalGPA'>المعدل التراكمي (من 4.0):</label></b>
                        <input
                            type="text"
                            value={originalGPA}
                            id='originalGPA'
                            onChange={(e) => setOriginalGPA(e.target.value)}
                            className='form-control'
                            style={{ width: '200px', marginRight: '4px' }}
                        />
                    </div>
                    <button className="btn btn-success mt-3" onClick={handleCalculateClick}>
                    احسب                    </button>
                    <br />
                </div>
            </div>
            <br />
            <div className="row">
                <div className="col-sm-12 col-md-7">
                    {error && <div className="alert alert-warning"><b><u> حدث خطأ :</u></b> يُرجى إدخال جميع الحقول بالشكل الصحيح. </div>}
                    {showResult &&  (
                        <div style={{ fontSize: '17px' }} className=" bg-light bg-gradient text-dark">
                            <div className="p-3 bg-success bg-gradient text-white">
                                <strong>النتائج:</strong>
                            </div>
                            <b>المعدل التراكمي على مقياس 5.0: {convertedGPA}</b>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
}
export default SharedGPA4to5;
